import React from 'react';
import { Box, Divider, SkeletonLoader } from '@drone-js/core';
import { CmsValue } from 'core/type/BootstrapConfig.types';

const ReviewSectionPlaceHolder: React.FC<{ cms: CmsValue }> = React.memo(({ cms }) => {
    const NO_OF_LOADER = 2;

    const loaderLabel = cms[326495];

    return (
        <div data-testid="activities-review-placeholder">
            <Divider mt="12" mb="16" />
            {Array.from({ length: NO_OF_LOADER }, (_, i) => {
                return (
                    <React.Fragment key={i}>
                        <Box display="flex" flexDirection="row">
                            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" me="12">
                                <SkeletonLoader label={loaderLabel} shape="circle" width="40px" height="40px" />
                            </Box>
                            <Box display="flex" flexDirection="column" justifyContent="center" width="100%">
                                <SkeletonLoader label={loaderLabel} shape="rectangle" width="15%" height="16px" my="4" />
                                <SkeletonLoader label={loaderLabel} shape="rectangle" width="20%" height="16px" my="4" />
                            </Box>
                        </Box>
                        <Box display="flex" flexDirection="row">
                            <Box display="flex" mt="8" flexDirection="column" width="100%">
                                <SkeletonLoader label={loaderLabel} shape="rectangle" width="40%" height="16px" mb="4" />
                                <SkeletonLoader label={loaderLabel} shape="rectangle" width="12%" height="16px" mb="4" />
                                <SkeletonLoader label={loaderLabel} shape="rectangle" width="95%" height="16px" mb="4" />
                                <SkeletonLoader label={loaderLabel} shape="rectangle" width="55%" height="16px" mb="4" />
                            </Box>
                        </Box>
                        <Box display="flex" flexDirection="row">
                            <Box my="8" display="flex" flexDirection="row">
                                <SkeletonLoader label={loaderLabel} shape="rectangle" width="90px" height="90px" me="4" />
                                <SkeletonLoader label={loaderLabel} shape="rectangle" width="90px" height="90px" me="4" />
                            </Box>
                        </Box>
                        <Divider mt="12" mb="12" />
                    </React.Fragment>
                );
            })}
        </div>
    );
});

ReviewSectionPlaceHolder.displayName = 'ReviewSectionPlaceHolder';

export default ReviewSectionPlaceHolder;
